/* eslint-disable react/no-array-index-key,react/no-unknown-property */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

const styles = theme => ({
  tabNav: {
    '&.withBorder': {
      borderRight: `1px solid ${theme.accordion.borderColor}`,
      paddingRight: '16px',
    },
    '& ul': {
      display: 'flex',
      flexDirection: 'column',
      listStyle: 'none',
      padding: '10px',
      margin: '0',
    },
    '& li': {
      maxWidth: '100%',
      wordWrap: 'break-word',
    },
  },
  title: {
    display: 'block',
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    color: `var(--gameday-tabs-tabSideHeadingColor, ${theme.tabs.tabSideHeadingColor})`,
    marginTop: 24,
    marginBottom: 12,
    '&:first-child': {
      marginTop: 0,
    },
  },
  item: {
    display: 'block',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-tabs-tabSideInActiveColor, ${theme.tabs.tabSideInActiveColor})`,
    padding: '9px 16px 9px',
    borderRadius: 18,
    marginBottom: 12,
    cursor: 'pointer',
    '&.active': {
      color: `var(--gameday-tabs-tabSideActiveColor, ${theme.tabs.tabSideActiveColor})`,
      backgroundColor: `var(--gameday-tabs-tabSideActiveBackgroundColor, ${theme.tabs.tabSideActiveBackgroundColor})`,
      '& .tab-num': {
        backgroundColor: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
        color: theme.colors.white,
        borderColor: `var(--gameday-tabs-tabActiveColor, ${theme.tabs.tabActiveColor})`,
      },
    },
  },
  tabNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    marginRight: '5px',
    border: `1px solid ${`var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`}`,
    borderRadius: '10px',
    fontSize: theme.typography.fontSizeTinyish,
  },
})
const SideTabNavigator = ({ activeTab, classes, onChangeTab, tabs, title, withBorder, withNumbers }) => (
  <div className={cn({ withBorder }, classes.tabNav)}>
    <ul>
      {title && <li className={classes.title}>{title}</li>}
      {tabs.map((tab, key) =>
        tab.show ? (
          // biome-ignore lint/complexity/noUselessFragments: TODO
          <>
            {tab.heading ? (
              <li className={classes.title}>{tab.heading}</li>
            ) : (
              // biome-ignore lint/a11y/noStaticElementInteractions: TODO
              <li
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key={key}
                role="presentation"
                onClick={() => onChangeTab(tab.value)}
                disable
                aria-label={tab.value}
                className={cn(
                  classes.item,
                  // eslint-disable-next-line no-nested-ternary
                  activeTab === tab.value
                    ? tab.disable
                      ? cn('disabled')
                      : 'active'
                    : tab.disable
                      ? cn('disabled')
                      : ''
                )}
              >
                {withNumbers && <span className={cn(classes.tabNumber, 'tab-num')}>{tab.value}</span>}
                {tab.title}
              </li>
            )}
          </>
        ) : null
      )}
    </ul>
  </div>
)

SideTabNavigator.defaultProps = {
  activeTab: '',
  onChangeTab: () => {},
  tabs: [],
  title: '',
  withBorder: false,
  withNumbers: false,
}

const SideTabNavigatorComponent = withStyles(styles)(SideTabNavigator)
SideTabNavigatorComponent.displayName = 'SideTabNavigator'
export default SideTabNavigatorComponent
